import React, { useState, useEffect, useContext } from "react";
import fetchHook from "../../hooks/fetchMSSQL-hook";
import { NavigationContext } from "../../context/navigation-context";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import moment from "moment";
import SearchFilter from "../../components/Filter/SearchFilter";

export default function Contractors() {
  const [windowHeight, setWindowHeight] = useState(window.innerHeight);
  const [contractors, setContractors] = useState([]);
  const { fetchMssqlApi } = fetchHook();
  const { setHeaderData } = useContext(NavigationContext);

  const defaultFilter = {
    page: 1,
    rowsPerPage: 50,
    isActive: "true",
    sortBy: "none",
  };

  const [filter, setFilter] = useState(defaultFilter);
  const [settingsFilter, setSettingsFilter] = useState({
    saveFilters: true,
    autoLoading: true,
    additionalFilter: true,
    flatView: false,
    rowsPerPage: 50,
  });

  const rowsPerPage = settingsFilter.rowsPerPage || filter.rowsPerPage || 50;

  useEffect(() => {
    const handleResize = () => {
      setWindowHeight(window.innerHeight);

      const screenHeight = window.innerHeight;
      const reservedSpace = 350;
      const visibleRows = Math.floor((screenHeight - reservedSpace) / 40);

      setFilter((prev) => ({
        ...prev,
        rowsPerPage: visibleRows > 50 ? 50 : visibleRows,
      }));
    };

    window.addEventListener("resize", handleResize);
    handleResize();

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const sortDefaults = {
    Name: "ASC",
    NIP: "ASC",
    Address: "ASC",
    ZipCode: "ASC",
    City: "ASC",
    Phone: "ASC",
    CreateDateTime: "DESC",
    IsActive: "DESC",
  };

  const handleHeaderSort = (field) => {
    const [curField, curDirRaw] = String(filter.sortBy || "").split("|");
    const curDir = (curDirRaw || "").toUpperCase();

    let nextDir;
    if (curField === field) {
      nextDir = curDir === "ASC" ? "DESC" : "ASC";
    } else {
      nextDir = sortDefaults[field] || "ASC";
    }

    const next = { ...filter, sortBy: `${field}|${nextDir}`, page: 1 };
    setFilter(next);
  };

  const getSortState = () => {
    const [field, dir] = String(filter.sortBy || "").split("|");
    return { field, dir: (dir || "").toUpperCase() };
  };

  const sortState = getSortState();

  const arrow = (field) => {
    if (sortState.field !== field) return "";
    return sortState.dir === "ASC" ? " ▲" : " ▼";
  };

  const getContractors = (f = filter) => {
    const sortBy = typeof f === "object" ? f?.sortBy : null;

    let url = `contractors`;
    if (sortBy && sortBy !== "none") {
      url += `?sortBy=${encodeURIComponent(sortBy)}`;
    }

    fetchMssqlApi(url, {}, (res) => setContractors(res || []));
  };

  const getCheckboxFromBool = (bool) => (
    <div className="d-flex justify-content-center align-items-center">
      <input type="checkbox" checked={!!bool} readOnly />
    </div>
  );

  useEffect(() => {
    setHeaderData({ text: "Kontrahenci" });
    getContractors();
  }, []);

  useEffect(() => {
    getContractors(filter);
  }, [filter]);

  const toBool = (v) => v === true || v === 1 || v === "1" || v === "true";

  const wantedActive = (v) => {
    if (v === true || v === "true") return true;
    if (v === false || v === "false") return false;
    return null;
  };

  const filtered = contractors.filter((t) => {
    const wanted = wantedActive(filter.isActive);
    if (wanted === null) return true;

    const active = toBool(t.IsActive);

    return wanted ? active : !active;
  });

  return (
    <div>
      <SearchFilter
        filterName="contractors"
        defaultFilter={defaultFilter}
        onFilterChange={(f) =>
          setFilter(prev => ({ ...prev, ...f }))
        }
        onSettingsChange={(s) =>
          setSettingsFilter(prev => ({ ...prev, ...s }))
        }
        search={getContractors}
        totalCount={filtered.length}
        dataList={contractors}
        forNow
      />
      <div className="card">
        <div className="card-header">
          <div>
            <div className="d-flex justify-content-between">
              <div></div>
              <Link
                to={`/contractor/0`}
                className="btn text-nowrap btn-outline-secondary mt-1 mb-1"
              >
                <i className="fas fa-plus" />
              </Link>
            </div>
          </div>
        </div>

        <div
          className="overflow-auto custom-scroll"
          style={{
            maxHeight: `${windowHeight - 216}px`,
            overflowY: "auto",
          }}
        >
          {filtered.length ? (
            <table className="table table-striped">
              <thead>
                <tr className="text-center headers-color">
                  <th
                    style={{ cursor: "pointer", userSelect: "none" }}
                    onClick={() => handleHeaderSort("Name")}
                  >
                    Kontrahent{arrow("Name")}
                  </th>
                  <th
                    style={{ cursor: "pointer", userSelect: "none" }}
                    onClick={() => handleHeaderSort("NIP")}
                  >
                    NIP{arrow("NIP")}
                  </th>
                  <th
                    style={{ cursor: "pointer", userSelect: "none" }}
                    onClick={() => handleHeaderSort("Address")}
                  >
                    Adres{arrow("Address")}
                  </th>
                  <th
                    style={{ cursor: "pointer", userSelect: "none" }}
                    onClick={() => handleHeaderSort("ZipCode")}
                  >
                    Kod pocztowy{arrow("ZipCode")}
                  </th>
                  <th
                    style={{ cursor: "pointer", userSelect: "none" }}
                    onClick={() => handleHeaderSort("City")}
                  >
                    Miasto{arrow("City")}
                  </th>
                  <th
                    style={{ cursor: "pointer", userSelect: "none" }}
                    onClick={() => handleHeaderSort("Phone")}
                  >
                    Telefon{arrow("Phone")}
                  </th>
                  <th
                    style={{ cursor: "pointer", userSelect: "none" }}
                    onClick={() => handleHeaderSort("CreateDateTime")}
                  >
                    Stworzony{arrow("CreateDateTime")}
                  </th>
                  <th
                    style={{ cursor: "pointer", userSelect: "none" }}
                    onClick={() => handleHeaderSort("IsActive")}
                  >
                    Aktywny{arrow("IsActive")}
                  </th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {filtered
                  .map((contractor, idx) => (
                    <tr key={idx} className="mt-1 mb-1">
                      <td>
                        <div className="d-flex justify-content-center">
                          {contractor.Name}
                        </div>
                      </td>
                      <td>
                        <div className="d-flex justify-content-center">
                          {contractor.NIP}
                        </div>
                      </td>
                      <td>
                        <div className="d-flex justify-content-center">
                          {contractor.Address}
                        </div>
                      </td>
                      <td>
                        <div className="d-flex justify-content-center">
                          {contractor.ZipCode}
                        </div>
                      </td>
                      <td>
                        <div className="d-flex justify-content-center">
                          {contractor.City}
                        </div>
                      </td>
                      <td>
                        {contractor.Phone ? (
                          <div className="d-flex justify-content-center">
                            {contractor.Phone}
                          </div>
                        ) : (
                          ""
                        )}
                      </td>
                      <td>
                        <div className="d-flex flex-column justify-content-center align-items-center mt-1">
                          <div className="d-flex justify-content-center">
                            {contractor &&
                              moment(contractor.CreateDateTime).format(
                                "YYYY.MM.DD"
                              )}
                          </div>
                        </div>
                      </td>
                      <td>
                        <div className="d-flex flex-column justify-content-center align-items-center mt-1">
                          <div className="d-flex justify-content-center">
                            {getCheckboxFromBool(contractor.IsActive)}
                          </div>
                        </div>
                      </td>
                      <td>
                        <Link
                          to={`contractor/${contractor.ContractorId}`}
                          className="btn btn-outline-primary btn-sm"
                        >
                          Edytuj
                        </Link>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          ) : (
            <div className="h3 d-flex justify-content-center align-items-center">
              Brak danych
            </div>
          )}
        </div>
      </div>
    </div>
  );
}